import { DISCOUNT_MODELS, type DiscountConfiguration } from '@vy/types';
import { isNotNullOrUndefined } from '@vy/utils';
import { isNumber } from 'lodash';

export function isPercentageDiscountOverLimit(
  // Accept a partial config: usage-product forms type discountConfiguration
  // with optional fields while it's being filled in.
  discountConfiguration: Partial<DiscountConfiguration> | undefined,
): boolean {
  return (
    isNotNullOrUndefined(discountConfiguration) &&
    discountConfiguration.type === DISCOUNT_MODELS.PERCENTAGE &&
    isNumber(discountConfiguration.amountToDeduct) &&
    discountConfiguration.amountToDeduct > 100
  );
}
